module.exports = __webpack_public_path__ + "img/back-to-the-top-arrow.23762609.svg";